import React from "react";

interface SessionInfoProps {
  sessionInfo: {
    playerName: string;
    domHand: string;
    sessionId: string;
    sessionDate: string;
  };
}

export const SessionInfo: React.FC<SessionInfoProps> = ({ sessionInfo }) => {
  return (
    <div className="mb-6" data-testid="session-info">
      <>
        <h3
          className="text-base font-semibold text-primary-800 mb-1"
          data-testid="player-name"
        >
          {sessionInfo.playerName}
        </h3>
        <div className="space-y-1 text-sm text-gray-800">
          <p data-testid="player-handedness">
            <span className="font-medium text-gray-500">Dominant Hand:</span>{" "}
            {sessionInfo.domHand}
          </p>
          <p data-testid="session-id" className="truncate">
            <span className="font-medium text-gray-500">Session ID:</span>{" "}
            {sessionInfo.sessionId}
          </p>
          <p data-testid="session-date">
            <span className="font-medium text-gray-500">Session Date:</span>{" "}
            {sessionInfo.sessionDate}
          </p>
        </div>
      </>
    </div>
  );
};
